import React, { useEffect, useState, useRef } from "react";
import logo from "../assets/logo.jpg";
import { translateToMarathi } from "../utils/marathiTranslator";
const toMarathi = async (text) => {
  if (!text) return "";
  try {
    const res = await fetch(
      `https://inputtools.google.com/request?text=${encodeURIComponent(text)}&itc=mr-t-i0-und&num=1`
    );
    const data = await res.json();
    if (data[0] === "SUCCESS") {
      let result = data[1][0][1][0];
      // Decode any HTML entities from the API
      const textarea = document.createElement("textarea");
      textarea.innerHTML = result;
      return textarea.value;
    }
    return text;
  } catch {
    return text;
  }
};

const toMarathiNumber = (num) => {
  if (num === null || num === undefined) return "";
  return num.toString().replace(/\d/g, (d) => "०१२३४५६७८९"[d]);
};

// ==================== MARATHI NUMBER TO WORDS ====================
const numberToMarathiWords = (num) => {
  if (num === 0 || num === null || num === undefined) return "शून्य";

  const belowTwenty = [
    "", "एक", "दोन", "तीन", "चार", "पाच", "सहा", "सात", "आठ", "नऊ", "दहा",
    "अकरा", "बारा", "तेरा", "चौदा", "पंधरा", "सोळा", "सतरा", "अठरा", "एकोणीस"
  ];

  const tens = [
    "", "", "वीस", "तीस", "चाळीस", "पन्नास", "साठ", "सत्तर", "ऐशी", "नव्वद"
  ];

  const hundreds = [
    "", "एकशे", "दोनशे", "तीनशे", "चारशे", "पाचशे", "सहाशे", "सातशे", "आठशे", "नऊशे"
  ];

  const scales = ["", "हजार", "लाख", "कोटी"];

  const convertLessThanThousand = (n) => {
    if (n === 0) return "";
    if (n < 20) return belowTwenty[n];
    if (n < 100) {
      const ten = Math.floor(n / 10);
      const rem = n % 10;
      return tens[ten] + (rem > 0 ? " " + belowTwenty[rem] : "");
    }
    const hundred = Math.floor(n / 100);
    const rem = n % 100;
    let result = hundreds[hundred];
    if (rem > 0) result += " " + convertLessThanThousand(rem);
    return result;
  };

  let result = "";
  let scaleIndex = 0;
  let tempNum = Math.floor(Math.abs(num));

  while (tempNum > 0) {
    let chunk;
    if (scaleIndex === 0) {
      chunk = tempNum % 1000;
      tempNum = Math.floor(tempNum / 1000);
    } else {
      chunk = tempNum % 100;
      tempNum = Math.floor(tempNum / 100);
    }

    if (chunk > 0) {
      let chunkWords = convertLessThanThousand(chunk);
      if (scaleIndex > 0) chunkWords += " " + scales[scaleIndex];
      result = chunkWords + (result ? " " + result : "");
    }
    scaleIndex++;
    if (scaleIndex > 3) break;
  }

  return result.trim() + " रुपये";
};
// ============================================================

const OccupancyTransferPrint = ({ data, onClose }) => {
  const [mrData, setMrData] = useState({});
  const [ready, setReady] = useState(false);

  const mode = data.mode || "EN";

  const copiesEN = [
    "Receipt (Copy for Department)",
    "Receipt (Copy for Concerned Payee)",
    "Receipt (Office Copy)",
  ];

  const copiesMR = [
    "पावती (विभागासाठी प्रत)",
    "पावती (अर्जदारासाठी प्रत)",
    "पावती (कार्यालयीन प्रत)",
  ];

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
  if (mode === "MR_RECEIPT" || mode === "MR") {
    const convert = async () => {
      try {
        const amountInMarathi = numberToMarathiWords(data.amount);

        const converted = {
          payee_name: await toMarathi(data.payee_name || ""),
          bank_name: translateToMarathi(data.bank_name || ""),
          remark: await toMarathi(data.remark || ""),
          payment_mode: await toMarathi(data.payment_mode || ""),
          fee_type: await toMarathi(data.fee_type || ""),
          amount_words: await toMarathi(data.amount_words || ""),
          dd_cheque_number: await toMarathi(data.dd_cheque_number || ""),
          receipt_date: await toMarathi(data.receipt_date?.slice(0, 10) || ""),
          dd_date: await toMarathi(data.dd_date ? data.dd_date.slice(0, 10) : ""),
          amount_words_marathi: amountInMarathi,
          contact_number: data.contact_number || "",
        };

        setMrData(converted);
        setReady(true);
      } catch (err) {
        console.error("Marathi conversion failed:", err);
        setReady(true); // Still allow printing even if conversion fails
      }
    };
    convert();
  } else {
    setReady(true);
  }
}, [data, mode]);

const hasPrinted = useRef(false);

useEffect(() => {
  if (!ready || hasPrinted.current) return;

  hasPrinted.current = true;

  const timer = setTimeout(() => {
    window.print();
  }, 300);

  const handleAfterPrint = () => {
    onClose?.();
  };

  window.addEventListener("afterprint", handleAfterPrint);

  return () => {
    clearTimeout(timer);
    window.removeEventListener("afterprint", handleAfterPrint);
  };
}, [ready, onClose]);

  if (!ready) return <div className="print-container"></div>;

const challanPageStyle = {
  display: 'block',
  width: '210mm',
  minHeight: '250mm',        // ← reduce from 290mm
  padding: '8mm',
  boxSizing: 'border-box',
  fontFamily: '"Times New Roman", serif',
  pageBreakAfter: 'always',  // ← add this
  pageBreakInside: 'avoid',
};

const challanPage2Style = {
  ...challanPageStyle,
  pageBreakBefore: 'always',
  pageBreakAfter: 'auto',    // ← no trailing blank page
};

  return (
    <div className="print-container">

      {/* ================= ENGLISH RECEIPT ================= */}
      {mode === "EN" && (
        <div className="a4-page receipt-page">
          {copiesEN.map((title, i) => (
            <div key={i} className="receipt">
              <div className="receipt-header">
                <img src={logo} alt="logo" className="logo" />
                <h2>Dharavi Redevelopment Project</h2>
                <p>Slum Rehabilitation Authority</p>
                <p>4th Floor, Gala Altazza, Udyog Nagar, Flank Road</p>
                <p>Beside Shanmukhanand Auditorium, Kings Circle, Sion, Mumbai-400022</p>
              </div>
              <div className="receipt-title">{title}</div>
              <div className="receipt-body">
                <div className="left">
                  <div className="row">Receipt No: {data.receipt_no}</div>
                  <div className="row">Challan No: {data.rbi_challan_no || "Nil"}</div>
                  <div className="row">Amount: Rs.{data.amount}/-</div>
                  <div className="row">Payee Name: {data.payee_name}</div>
                  <div className="row">By: {data.payment_mode}</div>
              <div className="row">Bank Name: {data.bank_name || "Nil"}</div>
                  <div className="row">Remark: {data.remark || "-"}</div>
                  <div className="amount-box">Rs.{data.amount}/-</div>
                </div>
                <div className="right">
                  <div className="row">Receipt Date: {formatDate(data.receipt_date)}</div>
                  <div className="row">Amount in words: {data.amount_words} </div>
                  <div className="row">Fee Type: {data.fee_type}</div>
                  <div className="row">
                    {data.payment_mode === "DD" ? "DD No" : "Cheque No"}: {data.dd_cheque_number || "Nil"}
                  </div>
                  <div className="row">
                    {data.payment_mode === "DD" ? "DD Date" : "Cheque Date"}: {data.dd_date ? formatDate(data.dd_date) : "Nil"}
                  </div>
                </div>
              </div>
              <div className="receipt-footer">
                <div>Assistant Account Officer / Cashier</div>
                              <div className="signature-space"></div>
           <div>Dharavi Redevelopment Project, Mumbai</div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ================= MR RECEIPT ================= */}
      {mode === "MR_RECEIPT" && (
        <div className="a4-page receipt-page">
          {copiesMR.map((title, i) => (
            <div key={i} className="receipt">
              <div className="receipt-header">
                <img src={logo} alt="logo" className="logo" />
                <h2>धारावी पुनर्विकास प्रकल्प</h2>
                <p>झोपडपट्टी पुनर्वसन प्राधिकरण</p>
                <p>चौथा मजला, गाला अल्टाझा, उद्योग नगर, फ्लँक रोड</p>
                <p>शनमुखानंद सभागृहाजवळ, किंग्ज सर्कल, सायन, मुंबई-४०००२२</p>
              </div>
              <div className="receipt-title">{title}</div>
              <div className="receipt-body">
                <div className="left">
                  <div className="row">पावती क्रमांक: {toMarathiNumber(data.receipt_no)}</div>
                  <div className="row">रक्कम: ₹{toMarathiNumber(data.amount)}/-</div>
                  <div className="row">देणाऱ्याचे नाव: {mrData.payee_name}</div>
                  <div className="row">द्वारे: {mrData.payment_mode}</div>
                  <div className="row">बँकेचे नाव: {mrData.bank_name}</div>
                  <div className="row">नोंद: {mrData.remark}</div>
                  <div className="amount-box">₹{toMarathiNumber(data.amount)}/-</div>
                </div>
                <div className="right">
                  <div className="row">पावती दिनांक: {mrData.receipt_date}</div>
                 <div className="row">
  शब्दात रक्कम: {mrData.amount_words_marathi}
</div>
                  <div className="row">शुल्क प्रकार: {mrData.fee_type}</div>
                  <div className="row">धनादेश क्रमांक: {mrData.dd_cheque_number}</div>
                  <div className="row">धनादेश दिनांक: {mrData.dd_date}</div>
                </div>
              </div>
              <div className="receipt-footer">
                <div>सहाय्यक लेखाधिकारी / रोखपाल</div>
                <div className="signature-space"></div>
                <div>धारावी पुनर्विकास प्रकल्प, मुंबई</div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ================= MR CHALLAN ================= */}
      {mode === "MR" && (
        <>
          {/* PAGE 1 */}
          <div style={challanPageStyle}>
            <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed", fontSize: "13px" }}>
              <colgroup>
                <col style={{ width: "42%" }} />
                <col style={{ width: "33%" }} />
                <col style={{ width: "25%" }} />
              </colgroup>
              <tbody>
                <tr>
                  <td colSpan="3" style={{ border: "1px solid black", padding: "6px 8px", textAlign: "center", fontWeight: "bold" }}>
                    नमुना म.को.नि-6
                  </td>
                </tr>
                {/* First Row */}
<tr>
  <td
    style={{
      border: "1px solid black",
      borderRight: "none",
      borderBottom: "none",
      padding: "6px 8px",
    }}
  >
    ये.का.मु.(25,00,000)8-200 पीअे5* एच-114
  </td>

  <td
    style={{
      border: "1px solid black",
      borderLeft: "none",
      borderRight: "none",
      borderBottom: "none",
      padding: "6px 8px",
    }}
  >
    (नियम 112 पहा )
  </td>

  <td
    style={{
      border: "1px solid black",
      borderLeft: "none",
      borderBottom: "none",
      padding: "6px 8px",
    }}
  ></td>
</tr>

{/* Second Row */}
<tr>
  <td
    style={{
      border: "1px solid black",
      borderRight: "none",
      borderTop: "none",
      borderBottom: "none",
      padding: "6px 8px",
    }}
  >
    शा.प.वित्त विभाग, क्र.संकीर्ण-1087/प्रक्र86/कोषा-4
  </td>

  <td
    style={{
      border: "1px solid black",
      borderLeft: "none",
      borderRight: "none",
      borderTop: "none",
      borderBottom: "none",
      padding: "6px 8px",
    }}
  >
    चलन क्रमांक.{data.challan_no}
  </td>

  <td
    style={{
      border: "1px solid black",
      borderLeft: "none",
      borderTop: "none",
      borderBottom: "none",
      padding: "6px 8px",
    }}
  >६११३००६००५</td>
</tr>

{/* Third Row */}
<tr>
  <td
    style={{
      border: "1px solid black",
      borderRight: "none",
      borderTop: "none",
      padding: "6px 8px",
    }}
  >
    दिनांक 22 सप्टेंबर 1987.
  </td>

  <td
    style={{
      border: "1px solid black",
      borderLeft: "none",
      borderRight: "none",
      borderTop: "none",
      padding: "6px 8px",
    }}
  >
   
  </td>

  <td
    style={{
      border: "1px solid black",
      borderLeft: "none",
      borderTop: "none",
      padding: "6px 8px",
    }}
  ></td>
</tr>
                <tr>
                  <td colSpan="3" style={{ border: "1px solid black", padding: "6px 8px", textAlign: "center" }}>
                    या ठिकाणच्या कोषागारात/उपकोषागारात भरण्यात आलेल्या रोख रक्कमेचे चलन भारतीय स्टेट बँकेमध्ये/ भारतीय रिझर्व बँकेमध्ये
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>भरणा करणाऱ्याने भरावयाचे R.B.I.Fort Mumbai</td>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>विभागीय अधिकाऱ्याने किंवा कोषागाराने भरावयाचे</td>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>
                    कोषागाराने/उपकोषागाराने/भारतीय रिझर्व बँक<br />
                    भारतीय स्टेट बँकेने/ हैद्राबाद स्टेट बँकेने भरावयाचे
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>
                    जिच्यावतीने रक्कम भरण्यात आली आहे त्या व्यक्तीचे नाव/ पदनाम आणि पत्ता<br />
                    धारावी पुनर्विकास प्रकल्प, पाचवा मजला, गृहनिर्माण भवन, म्हाडा,<br />
                    वांद्रे (पू), मुंबई- 400 051.<br />
                    Email: fcdrpsra@gmail.com
                  </td>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>लेख्या वर्गिकरण</td>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>रक्कम मिळाली</td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>भरणा करण्यासंबंधीच्या प्राधिकारपत्राचा तपशिल आणि भरणा करण्याचा उद्देश</td>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>विभाग- धारावी पुनर्विकास प्रकल्प</td>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>रूपये (आकड्यात) - ₹{toMarathiNumber(data.amount)}/-</td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>
                    {mrData.payee_name} यांचेकडून स्वीकारण्यात आलेली भोगवटा हस्तांतरण शुल्क
                  </td>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>प्रधानशीर्ष - 0216 गृहनिर्माण, 02 नागरी गृहनिर्माण</td>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>
                    रूपये (अक्षरी) - {mrData.amount_words_marathi}
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>भरणा केलेली रक्कम रू. ₹{toMarathiNumber(data.amount)}/-</td>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>उपप्रधानशीर्ष-800 इतर रकमा (01)(01)</td>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}></td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>{mrData.amount_words_marathi}</td>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>संगणक संकेतांक</td>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>कोषपाल-</td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>भरणा करणाऱ्याची स्वाक्षरी</td>
                   <td style={{ 
                    border: "1px solid black", 
                    padding: "6px 8px", 
                    fontWeight: "bold", 
                    fontSize: "16px" 
                  }}>
                    ० २ १ ६ ० ० २ २ ० १
                  </td>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>लेखापाल-</td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>
                    दिनांक {new Date().toLocaleDateString('mr-IN')}<br />
                    
                  </td>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>बरोबर आहे, पैसे स्वीकारावे व पावती द्यावी</td>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>
                    कोषागार/उपकोषागर अधिकारी/ बँकेचा व्यवस्थापक
                    <div style={{ height: "60px" }}></div>
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>Contact: {mrData.contact_number}</td>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>
                    <div style={{ height: "50px" }}></div>
                    दिनांक &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; स्वाक्षरी
                  </td>
                  <td style={{ border: "1px solid black", padding: "6px 8px" }}>दिनांक</td>
                </tr>
              </tbody>
            </table>
            <div style={{ marginTop: "40px", fontSize: "13px" }}>
              DHARAVI REDEVELOPMENT PROJECT<br />
              5TH FLOOR, MHADA BUILDING,<br />
              BANDRA (EAST) 400 051
            </div>
          </div>

          {/* PAGE 2 */}
          <div className="challan-page-break" style={challanPage2Style}>
            {/* PAGE 2 content same as before */}
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
              <colgroup>
                <col style={{ width: "65%" }} />
                <col style={{ width: "35%" }} />
              </colgroup>
              <tbody>
                <tr>
                  <td style={{ border: "1px solid black", padding: "6px 8px", fontWeight: "bold", textAlign: "center" }}>भरण्याच्या रकमेचा तपशिल</td>
                  <td style={{ border: "1px solid black", padding: "6px 8px", fontWeight: "bold", textAlign: "center" }}>सूचना</td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black", padding: 0 }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr>
                          <td style={{ width: "15%", border: "1px solid black", padding: "6px 8px" }}>नोटा</td>
                          <td style={{ width: "55%", border: "1px solid black", padding: "6px 8px" }}>झोपडीधारकाचे नाव</td>
                          <td style={{ width: "30%", border: "1px solid black", padding: "6px 8px" }}>रक्कम रूपये</td>
                        </tr>
                        <tr>
                          <td style={{ border: "1px solid black", padding: "6px 8px" }}>1</td>
              <td style={{ border: "1px solid black", padding: "6px 8px" }}>
  {mrData.payee_name}
  <br />
  यांचेकडून भोगवटा हस्तांतरण शुल्क
  <br />

  {{
    Residential: "निवासी",
    Commercial: "व्यावसायिक",
    "Residential + Commercial": "निवासी + व्यावसायिक",
    Other: "इतर",
  }[data.fee_type?.trim()] || data.fee_type}
</td>
                          <td style={{ border: "1px solid black", padding: "6px 8px" }}>{toMarathiNumber(data.amount)}</td>
                        </tr>
                        <tr>
                          <td colSpan="3" style={{ border: "1px solid black", padding: "6px 8px", height: "120px" }}></td>
                        </tr>
                        <tr>
                          <td colSpan="2" style={{ border: "1px solid black", padding: "6px 8px", fontWeight: "bold" }}>एकूण</td>
                          <td style={{ border: "1px solid black", padding: "6px 8px", fontWeight: "bold" }}>{toMarathiNumber(data.amount)}</td>
                        </tr>
                        <tr>
                          <td colSpan="2" style={{ border: "1px solid black", padding: "6px 8px", fontWeight: "bold" }}>धनादेश</td>
                          <td style={{ border: "1px solid black", padding: "6px 8px" }}>रक्कम रूपये</td>
                        </tr>
                        <tr>
                          <td style={{ border: "1px solid black", padding: "6px 8px" }}>धनादेश क्रमांक</td>
                          <td style={{ border: "1px solid black", padding: "6px 8px" }}>दिनांक</td>
                          <td style={{ border: "1px solid black", padding: "6px 8px" }}>आदेशित बँक व तिची शाखा</td>
                        </tr>
                        <tr>
                          <td style={{ border: "1px solid black", padding: "6px 8px" }}>{mrData.dd_cheque_number}</td>
                         <td style={{ border: "1px solid black", padding: "6px 8px" }}>
  {mrData.dd_date
    ? mrData.dd_date.split("-").reverse().join("/")
    : ""}
</td>
                          <td style={{ border: "1px solid black", padding: "6px 8px" }}>{mrData.bank_name}</td>
                        </tr>
                        <tr>
                          <td colSpan="2" style={{ border: "1px solid black", padding: "6px 8px", fontWeight: "bold" }}>एकूण</td>
                          <td style={{ border: "1px solid black", padding: "6px 8px", fontWeight: "bold" }}>{toMarathiNumber(data.amount)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td style={{ border: "1px solid black", verticalAlign: "top", padding: "10px" }}>
                    <div><b>सूचना</b></div><br />
                    <div>1. विभागाचे नाव भरताना ज्याच्याकरिता रक्कम जमा करावयाची असेल त्या विभागाचे नाव लिहावे</div><br />
                    <div>2. अर्थसंकल्पीय अंदाजातील लेख्याच्या वर्गीकरणाचे संदर्भित लेख्याचे प्रधानशिर्ष, उपप्रधानशीर्ष व गौणशीर्ष या बाबतचा तपशिल स्पष्टपणे, ठळकपणे नमुद करावा. शक्यतोवर रबरी शिक्का वापरावा.</div><br />
                    <div>3. भरण्याच्या रकमेच्या प्राधिकारविषयीचा तपशिल भरण्याच्या रकमेच्या उद्देशाविषयीच्या वर्णनाबरोबरच स्पष्ट शब्दात नमूद करावा.</div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div style={{ marginTop: "40px", fontSize: "13px" }}>
              DHARAVI REDEVELOPMENT PROJECT<br />
              5TH FLOOR, MHADA BUILDING,<br />
              BANDRA (EAST) 400 051
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default OccupancyTransferPrint;